import {Link as RouterLink} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import './ContactUsButton.css'

interface Props {
  className?: string
}

const ContactUsButton = ({className}: Props) => {
  const {t} = useTranslation()
  return (
    <RouterLink to="/contact" className={className ? `contact-us-btn ${className}` : 'contact-us-btn'}>
      {t('contactUsButton.label')}
      <svg
        width={14}
        height={14}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <path d="M5 12h14" />
        <path d="M13 5l7 7-7 7" />
      </svg>
    </RouterLink>
  )
}

export default ContactUsButton
